
import { Breadcrumb } from "antd"
import React from "react"
import { useState } from "react"
import DynamicSelect from "../../shared/DynamicSelect"
import { getStyle, regularInputClass, regularSelectClass } from "../../../styles/styles"
import DatePicker from "../../shared/DatePicker"
import { formatDate } from "../../../helpers/FormatHelper"
import NewEditableGrid from "../../shared/NewEditableGrid"
import { EditOutlined } from "@material-ui/icons"
import { getBNAdjustment } from "../../../networking/NetworkingBNAdjustment"

const  AdjustmentsSearch = ({addAdjustment, vaultList, referenceTypeList, onAdjustmentSelected}) => {

    const style = getStyle();
    const classNameInputName = regularInputClass;
    const classNameSelect = regularSelectClass;
    const [vault, setVault] = useState(-1);
    const [referenceType, setReferenceType] = useState('');
    const [valueDateFrom, setValueDateFrom] = useState('');
    const [valueDateTo, setValueDateTo] = useState('');
    const [adjustments, setAdjustments] = useState([]);
    const [columnDetail, setColumnDetail] = useState([]);

    const handleSearchClick = () =>{

    }

    const handleClearClick = () =>{
        setVault(-1);
        setReferenceType('');
        setValueDateFrom('');
        setValueDateTo('');
    }

    const handleAddCustomerClick = () =>{
        addAdjustment();
    }

    const updateVault = async (item) => {
      if(item.value && item.value !== '')
      {
        setVault(item.value);
      }
    }
    
    const updateReferenceType = async (item) => {
      if(item.value && item.value !== '')
      {
        setReferenceType(item.value);
      }
    }

    const handleUpdateValueDateFrom = (date) => {
        if (date !== undefined) {
            setValueDateFrom(formatDate(date));
        } else {
            setValueDateFrom('');
        }
    }

    const handleUpdateValueDateTo = (date) => {
        if (date !== undefined) {
            setValueDateTo(formatDate(date));
        } else {
            setValueDateTo('');
        }
    }

    const handleRowClick = async(obj)=>{
        if(onAdjustmentSelected)
        {
            const responseAdjustment= await getBNAdjustment(obj.AdjustmentID);
            if(responseAdjustment)
            {
                onAdjustmentSelected(responseAdjustment);
            }
        }
    }
            

    return (<>

        <div className="uk-grid uk-margin">
            <div className="uk-width-1-1">
                <div className="uk-grid">
                   <div className="uk-width-1-6 uk-form-stacked">
                        <label className="uk-form-label" htmlFor="form-vault">Vault</label>
                        <div className="" style={style.inputStyle}>
                            <DynamicSelect className={classNameSelect} objValue={{ value: vault }} getValue={updateVault} 
                            placeholder={"Select an item..."} listHasPlaceholder={false} data={vaultList} id="form-vault" />
                        </div>
                    </div>
                    <div className="uk-width-1-6 uk-form-stacked">
                        <label className="uk-form-label" htmlFor="form-referenceType">Reference Type</label>
                        <div className="" style={style.inputStyle}>
                            <DynamicSelect className={classNameSelect} objValue={{ value: referenceType }} getValue={updateReferenceType} 
                            placeholder={"Select an item..."} listHasPlaceholder={false} data={referenceTypeList} id="form-referenceType" />
                        </div>
                    </div>
                    <div className="uk-width-1-6 uk-form-stacked">
                        <label className="uk-form-label" htmlFor="form-valueDateFrom">Date From</label>
                        <div className="" style={style.inputStyle}>
                            <DatePicker className={classNameInputName} value={valueDateFrom} onDayChange={handleUpdateValueDateFrom} />
                        </div>
                    </div>
                
                    <div className="uk-width-1-6 uk-form-stacked">
                        <label className="uk-form-label" htmlFor="form-valueDateTo">Date To</label>
                        <div className="" style={style.inputStyle}>
                            <DatePicker className={classNameInputName} value={valueDateTo} onDayChange={handleUpdateValueDateTo} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="uk-width-1-1" style={{ marginTop: '15px' }}>
                <button className="uk-button uk-button-green" onClick={handleSearchClick}>Search</button>
                <button className="uk-button uk-button-green" onClick={handleClearClick}>Clear Fields</button>
                <button className="uk-button uk-button-green" onClick={handleAddCustomerClick}>Add</button>
            </div>
        </div>
         <hr/>
        <div>
            <NewEditableGrid
                data={adjustments}
                columnDetails={columnDetail}
                isEditable={false}         
                useIcons={true}
                dynamicActions={[{name: 'Edit', function: handleRowClick, isIcon: true, icon: <EditOutlined /> }]} />
                        
        </div>
    </>)

}
export default AdjustmentsSearch